module.exports = __webpack_public_path__ + "img/fushimi-HP-pattern001.cd20a28d.png";